var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3 2.5C3.3 1.39543 4.24021 0.5 5.4 0.5H8.9C9.08564 0.5 9.26372 0.570238 9.39497 0.695262L14.295 5.36193C14.4262 5.48695 14.5 5.65652 14.5 5.83333V11.8333C14.5 12.9379 13.5598 13.8333 12.4 13.8333H11.7V14.5C11.7 15.6046 10.7598 16.5 9.6 16.5H2.6C1.4402 16.5 0.5 15.6046 0.5 14.5V5.16667C0.5 4.0621 1.4402 3.16667 2.6 3.16667H3.3V2.5ZM3.3 4.5H2.6C2.2134 4.5 1.9 4.79848 1.9 5.16667V14.5C1.9 14.8682 2.2134 15.1667 2.6 15.1667H9.6C9.98661 15.1667 10.3 14.8682 10.3 14.5V13.8333H5.4C4.24021 13.8333 3.3 12.9379 3.3 11.8333V4.5ZM5.4 1.83333C5.0134 1.83333 4.7 2.13181 4.7 2.5V11.8333C4.7 12.2015 5.0134 12.5 5.4 12.5H12.4C12.7866 12.5 13.1 12.2015 13.1 11.8333V6.5H10.3C9.14017 6.5 8.2 5.60457 8.2 4.5V1.83333H5.4ZM9.6 2.77614L12.1101 5.16667H10.3C9.91339 5.16667 9.6 4.86819 9.6 4.5V2.77614Z",
    fill: "#4B5258"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.91e044908096aee1c28a3ec103699ea5.svg";
export { ForwardRef as ReactComponent };